import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 3 · NIVEAU 2 — LES LAMES.

     0:00  bloc F3       28 s   les lames — laser du Sabreur, spirale du Tourbillon
     0:28  respiration    4 s
     0:32  bloc G1       26 s   crête : les six natures ensemble
     0:58  respiration    4 s

   Deuxième niveau du monde 3, sans boss. F3 introduit les menaces horizontales,
   G1 les réunit toutes avant le niveau final.

   ⚠️ Blocs 5 → 8 de l'ancien `monde-3`, re-basés (offset 74 s).
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-3-2',
  duration: 62,
  blocks: [
    // Champ dense de rochers tardifs — noyau et colosse ensemble, tout à droite,
    // pour que les menaces horizontales des Lames et le terrain solide se lisent
    // sur deux moitiés d'écran distinctes.
    {
      at: 0,
      wave: 'f3-lames',
      obstacles: [
        { at: 4, obstacle: 'astero-noyau', x: 200 },
        { at: 9, obstacle: 'astero-eclat', x: -220 },
        { at: 14, obstacle: 'astero-colosse', x: 255 },
        // Le mastodonte : le faire sauter remplit l'écran de fragments à esquiver
        // dans la foulée, un vrai choix au milieu des Lames.
        { at: 19, obstacle: 'astero-mastodonte', x: 150 },
      ],
    },
    { at: 28, wave: 'respiration' },
    // Un second complexe, plus léger (une seule sentinelle), sur la crête où
    // toutes les natures se réunissent : le caisson armé y est une menace de
    // plus à intégrer, posée à droite cette fois. Et, sur la gauche, une PLATEFORME
    // VOLANTE — un radeau qui ONDULE en descendant, portant une tourelle qui le
    // CHEVAUCHE (elle louvoie avec lui). Indestructible : on démonte son canon, ou
    // on danse avec elle. Les deux porteurs armés ferment chacun un flanc, sans
    // jamais couper le centre.
    {
      at: 32,
      wave: 'g1-crete',
      obstacles: [
        {
          at: 5,
          obstacle: 'complexe-caisson',
          x: 215,
          sentinels: [{ enemy: 'mortier', offX: 0, offY: 24 }],
        },
        {
          at: 12,
          obstacle: 'radeau',
          x: -175,
          sentinels: [{ enemy: 'mortier', offX: 0, offY: 22, ride: true }],
        },
      ],
    },
    { at: 58, wave: 'respiration' },
  ],
});
